import React from "react";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import {
  GetLineServiceText,
  GetInitialPackageText,
  SeparateCountryCodeFromNumber,
  ToPersianNumber,
} from "../../../functions/index";
import Constants from "../../../constants/constants";
import Headings from "../../../constants/headings";
function LinesTables(props) {
  return (
    <>
      <h2>{Headings.ServiceLinesHeading}</h2>
      <Row>
        <Col>
          <Table responsive className="roundedCorners">
            <thead>
              <tr>
                {props.heading.map((h, index) => (
                  <th key={index}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {props.data &&
                props.data.map((d, index) => (
                  <tr key={index}>
                    <td className="ltr">
                      {ToPersianNumber(SeparateCountryCodeFromNumber(d.LineNumber))}
                    </td>
                    <td className={d.IsEnabled ? "enabled" : "disabled"}>
                      {d.IsEnabled ? Constants.On : Constants.Off}
                    </td>
                    <td>
                      {GetInitialPackageText(d.InitialPackage)}
                    </td>
                    <td>{GetLineServiceText(d.LineServiceType)}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
}
export default LinesTables;
